import React from "react";
import {
  IFallbackClientAffiliateLink
} from "../../api/match-center";
import bn from '../../utils/bemnames';
import {
  generateCdnProxyImageUrl
} from "../../utils/helpers";
import {
  formatOdds,
  getOutLink
} from "../../utils/odds";
import {
  getOutcomeLetter,
  Outcomes
} from "../../utils/outcome";
import {
  baseSportsIndexDomain
} from "../../utils/request";
import {
  EventStatus,
  IProvider,
  oddsFormats
} from "../../utils/types";
import ImgWithDefault from "../ImgWithDefault";
import OddsTrackingLink from "../OddsTrackingLink";

const bem = bn.create("football-odds-button");

interface IProps {
  oddsLine: number | null;
  widgetId: number;
  outLinkFolder: string | null;
  oddsFormat: oddsFormats;
  eventId: number;
  provider: IProvider | null;
  builderComponentId: number;
  outcome: Outcomes;
  fallbackClientAffiliateLinks?: IFallbackClientAffiliateLink[];
  isMobile: boolean;
  eventStatus: string;
  oddsPrev: number | null;
}

const OddsButtonWithOperatorLogoAndOutcome: React.FC<IProps> = (props) => {
  const {
    widgetId,
    outLinkFolder,
    eventId,
    oddsLine,
    oddsFormat,
    builderComponentId,
    outcome,
    provider,
    fallbackClientAffiliateLinks = undefined,
    isMobile,
    eventStatus,
    oddsPrev,
  } = props;

  return (
    <>
      {oddsLine && provider ? (
        <div
          className={`${bem.b()} ${isMobile ? bem.b() + "--mobile" : ""} ${
            eventStatus === EventStatus.Inprogress ? bem.b() + "__live" : ""
          }`}
        >
          <OddsTrackingLink
            className={bem.e("link")}
            outLink={getOutLink(outLinkFolder, provider.slug, widgetId, eventId, builderComponentId)}
            target={'_blank'}
            rel={'noreferrer'}
            providerId={provider.id}
            widgetId={widgetId}
          >
            <div className={bem.e("outcome-name")}>{getOutcomeLetter(outcome)}</div>
            <div className={bem.e("odds")}>
              {formatOdds(oddsLine, oddsFormat)}
              {oddsPrev &&
                oddsLine &&
                (oddsPrev < oddsLine ? (
                  <div className={bem.e("drifting")}>▲</div>
                ) : (
                  <div className={bem.e("shortening")}>▼</div>
                ))}
            </div>
            <div className={bem.e("provider-logo")}>
              <ImgWithDefault
                src={
                  provider?.squareLogoUrl
                    ? generateCdnProxyImageUrl(baseSportsIndexDomain + provider?.squareLogoUrl)
                    : ""
                }
                alt={provider.name}
              />
            </div>
          </OddsTrackingLink>
        </div>
      ) : (
        <>
          {fallbackClientAffiliateLinks && fallbackClientAffiliateLinks[0] && provider && (
            <div
              className={`${bem.b()} ${isMobile ? bem.b() + "--mobile" : ""} ${
                eventStatus === EventStatus.Inprogress ? bem.b() + "__live" : ""
              }`}
            >
              <OddsTrackingLink
                className={bem.e("link")}
                outLink={getOutLink(
                  outLinkFolder,
                  fallbackClientAffiliateLinks[0].provider.slug,
                  widgetId,
                  eventId,
                  builderComponentId
                )}
                providerId={provider.id}
                widgetId={widgetId}
              >
                <div className={bem.e("outcome-name")}>{getOutcomeLetter(outcome)}</div>
                <div className={bem.e("odds")}> - </div>
                <div className={bem.e("provider-logo")}>
                  <ImgWithDefault
                    src={
                      provider?.squareLogoUrl
                        ? generateCdnProxyImageUrl(`${baseSportsIndexDomain}${provider?.squareLogoUrl}`)
                        : ""
                    }
                    alt={fallbackClientAffiliateLinks[0].provider.name}
                  />
                </div>
              </OddsTrackingLink>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default OddsButtonWithOperatorLogoAndOutcome;
